
import i18n from '@/lang';
import PageHeader from '@/components/PageHeader.vue'
import PageFooter from '@/components/PageFooter.vue'
import { Component, Vue } from 'vue-property-decorator'

import { tableDataEn } from '@/json/table'

@Component({
  components: {
    PageHeader,
    PageFooter
  }
})
export default class extends Vue {
  get lang() {
    return i18n.locale;
  }

  get tableData() {
    if (this.lang === 'zh') {
      return tableDataEn
    } else {
      return tableDataEn
    }
  }

  get showScroll() {
    const winWidth = window.screen.width;
    if (winWidth < 750) {
      return true
    }
    console.log(winWidth);
    return false
  }

  getImgUrl(imgUrl: string) {
    return require('@/assets/img/sponsor/'+imgUrl)
  }

  getTableCellStyle({ rowIndex }: any) {
    if (rowIndex === 7) {
      return {
        borderBottom: '6px solid #006e95'
      }
    }
  }
}
